import React from 'react';
import { Checkbox, Empty } from 'antd';
import { priorityMeta, TB_COLORS } from './utils';
import { PriorityDot, StatusPill, TagPills, DueLabel, LocationLabel, Assignees } from './bits';

const ListView = ({ tasks, areaMap, propertyName, onEdit, onToggleComplete }) => {
  if (!tasks.length) {
    return <Empty description="No tasks match your filters" style={{ marginTop: 64 }} />;
  }
  return (
    <div style={{ border: '1px solid #eaecf0', borderRadius: 12, overflow: 'hidden', background: '#fff' }}>
      {tasks.map((task, i) => (
        <div
          key={task.id}
          onClick={() => onEdit(task)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            padding: '14px 18px',
            borderTop: i === 0 ? 'none' : '1px solid #f2f4f7',
            borderLeft: `4px solid ${priorityMeta(task.priority).color}`,
            cursor: 'pointer',
            background: '#fff',
          }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
              checked={task.status === 'completed'}
              onChange={(e) => onToggleComplete(task, e.target.checked)}
            />
          </div>
          <PriorityDot priority={task.priority} />

          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                fontWeight: 600,
                fontSize: 15,
                color: TB_COLORS.text,
                textDecoration: task.status === 'completed' ? 'line-through' : 'none',
                opacity: task.status === 'completed' ? 0.6 : 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {task.title}
            </div>
            <div style={{ marginTop: 4 }}>
              <LocationLabel task={task} areaMap={areaMap} propertyName={propertyName} />
            </div>
          </div>

          <TagPills tags={task.tags} />
          <Assignees task={task} />
          <div style={{ minWidth: 70, textAlign: 'right' }}>
            <DueLabel task={task} />
          </div>
          <div style={{ minWidth: 96, textAlign: 'right' }}>
            <StatusPill status={task.status} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListView;
